import {action, makeObservable, observable, runInAction} from "mobx";
import {BaseListStore} from "app/modules/common/stores/BaseListStore";
import {inject} from "react-ioc";
import {ApiClients} from "app/modules/company/services/AxiosBaseClient";
import {FieldState, FormState} from "formstate";
import {
    CompanyIntegrationLogListFilters,
    CompanyIntegrationLogListModel,
    CompanyIntegrationLogType,
    DataListGetParamsOfCompanyIntegrationLogListFilters,
} from "app/modules/company/api/clients.api";

export class CompanyIntegrationLogsStore extends BaseListStore<CompanyIntegrationLogListModel> {
    @inject companyApiClients: ApiClients;

    integrationId: number = 0;
    integrationName: string = "";

    filters = new FormState({
        type: new FieldState<number | "">("")
    });

    constructor() {
        super();

        makeObservable(this, {
            integrationId: observable,
            integrationName: observable,
            init: action
        });
    }

    applySpecificFilters() {
    }

    async loadData() {
        if (!this.integrationId) return;

        this.wrapLoadingApiCall(async () => {
            const typeVal = this.filters.$.type.value;
            const filter = new CompanyIntegrationLogListFilters({
                companyIntegrationId: this.integrationId,
                type: typeVal === "" ? undefined : (typeVal as CompanyIntegrationLogType)
            });
            const result = await this.companyApiClients.companyIntegrationClient.getLogList(
                new DataListGetParamsOfCompanyIntegrationLogListFilters({
                    offset: this.skipRows,
                    pageSize: this.pageSize,
                    filter
                })
            );

            this.items = result.items || [];
            this.totalRows = result.count || 0;
        });
    }

    async init(integrationId: number) {
        this.integrationId = integrationId;

        await this.wrapInitLoadingApiCall(async () => {
            const [byId] = await Promise.all([
                this.companyApiClients.companyIntegrationClient.getById(integrationId),
                this.loadData()
            ]);
            runInAction(() => {
                this.integrationName = byId?.name || "";
            });
        });
    }
}
